import Vue from 'vue'
import VueRouter from 'vue-router'

// import HPProjectRealtime from '../views/credit_project/HPProjectRealtime'
// import HPProjectAnalysis from "../views/credit_project/HPProjectAnalysis";
// import HPCompileHostAnalysis from "../views/credit_project/HPCompileHostAnalysis";
// import HPCompileUnitAnalysis from "../views/credit_project/HPCompileUnitAnalysis";
// import HPPubliceSupervision from "../views/credit_project/HPPublicSupervision";
// import HPDataSearch from "../views/credit_project/HPDataSearch";

// const HPProjectRealtime = () => import('../views/credit_project/HPProjectRealtime');
// const HPProjectAnalysis = () => import('../views/credit_project/HPProjectAnalysis');
// const HPCompileHostAnalysis = () => import('../views/credit_project/HPCompileHostAnalysis');
// const HPCompileUnitAnalysis = () => import('../views/credit_project/HPCompileUnitAnalysis');
// const HPPubliceSupervision = () => import('../views/credit_project/HPPublicSupervision');
// const HPDataSearch = () => import('../views/credit_project/HPDataSearch');

//v2

const Homev2 = () => import('../views/v2/credit_project/Homev2')
const HPDataSearchv2 = () => import('../views/v2/credit_project/HPDataSearchv2')
const HPPubliceSupervisionv2 = () => import('../views/v2/credit_project/HPPubliceSupervisionv2')
const HPProjectRealtimev2 = () => import('../views/v2/credit_project/HPProjectRealtimev2')
const HPProjectAnalysisv2 = () => import('../views/v2/credit_project/HPProjectAnalysisv2')
const HPCompileUnitAnalysisv2 = () => import('../views/v2/credit_project/HPCompileUnitAnalysisv2')
const HPCompileHostAnalysisv2 = () => import('../views/v2/credit_project/HPCompileHostAnalysisv2')

// import Homev2 from "../views/v2/credit_project/Homev2";
// import HPDataSearchv2 from "../views/v2/credit_project/HPDataSearchv2";
// import HPPubliceSupervisionv2 from "../views/v2/credit_project/HPPubliceSupervisionv2";
// import HPProjectRealtimev2 from '../views/v2/credit_project/HPProjectRealtimev2'
// import HPProjectAnalysisv2 from "../views/v2/credit_project/HPProjectAnalysisv2";
// import HPCompileUnitAnalysisv2 from "../views/v2/credit_project/HPCompileUnitAnalysisv2";
// import HPCompileHostAnalysisv2 from "../views/v2/credit_project/HPCompileHostAnalysisv2";

Vue.use(VueRouter)

const routes = [
  // v1 ----------------------------------------------------s

  // {
  //     path: '/credit-project/realtime',
  //     name: 'HPProjectRealtime',
  //     component: HPProjectRealtime,
  // },
  // {
  //     path: '/credit-project/project-analysis',
  //     name: 'HPProjectAnalysis',
  //     component: HPProjectAnalysis
  // },
  // {
  //     path: '/credit-project/compile-unit-analysis',
  //     name: 'HPCompileUnitAnalysis',
  //     component: HPCompileUnitAnalysis
  // },
  // {
  //     path: '/credit-project/compile-host-analysis',
  //     name: 'HPCompileHostAnalysis',
  //     component: HPCompileHostAnalysis
  // },
  //
  // {
  //     path: '/credit-project/public-supervision/',
  //     name: 'HPPubliceSupervision',
  //     component: HPPubliceSupervision
  // },
  //
  // {
  //     path: '/credit-project/data-search',
  //     name: 'HPDataSearch',
  //     component: HPDataSearch
  // },

  // v2: -------------------------------------------------------------------
  {
    path: '',
    redirect: 'index'
  },
  // 主页
  {
    path: '/index',
    name: Homev2,
    component: Homev2
  },
  // 实时数据
  {
    path: '/v2/credit-project/realtime',
    name: 'HPProjectRealtimev2',
    component: HPProjectRealtimev2
  },
  // 项目统计分析
  {
    path: '/v2/credit-project/project-analysis',
    name: 'HPProjectAnalysisv2',
    component: HPProjectAnalysisv2
  },
  // 编制单位分析
  //   {
  //     path: '/v2/credit-project/compile-unit-analysis',
  //     name: 'HPCompileUnitAnalysisv2',
  //     component: HPCompileUnitAnalysisv2
  //   },
  // 编制主持人分析
  //   {
  //     path: '/v2/credit-project/compile-host-analysis',
  //     name: 'HPCompileHostAnalysisv2',
  //     component: HPCompileHostAnalysisv2
  //   },
  // 公众监督
  // {
  //     path: '/v2/credit-project/public-supervision',
  //     name: 'HPPubliceSupervisionv2',
  //     component: HPPubliceSupervisionv2
  // },
  // 数据查询：
  {
    path: '/v2/credit-project/data-search',
    name: 'HPDataSearchv2',
    component: HPDataSearchv2
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
